import { useContext, useMemo } from 'react';

import { VFlex } from '@/components/base';
import taxonomyUtils from '@/features/Taxonomy/utils/taxonomy';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import TaxonomyContext from '../../../context/TaxonomyContext';
import { buildTaxonomyTopicPath } from '../../../utils/routes';
import ShortTopicRow from '../../ShortTopicRow/ShortTopicRow';

type Props = {
  isSearchResult: boolean;
  topicData: Topic2TreeItemT<TOPIC_2_TYPE>[];
  currentTopic?: string;
  createTopicCallback: (targetTopicAlias: string) => void;
};

const TopicNavigator = (props: Props) => {
  const { taxonomyAlias, sortBy, order } = useContext(TaxonomyContext);
  const wr = useWorkspaceRouter();
  if (!taxonomyAlias) {
    throw new Error('Taxonomy alias is required');
  }

  const sortedData = useMemo(() => {
    return taxonomyUtils.topicSortFunc(props.topicData, sortBy, order);
  }, [order, props.topicData, sortBy]);

  return (
    <VFlex>
      {sortedData.map((t) => (
        <ShortTopicRow
          showPath={props.isSearchResult}
          currentTopicAlias={props.currentTopic}
          key={t.alias}
          topic={t}
          createTopicCallback={props.createTopicCallback}
          onClick={(topicAlias) =>
            wr.push(buildTaxonomyTopicPath(taxonomyAlias, topicAlias))
          }
        />
      ))}
    </VFlex>
  );
};

export default TopicNavigator;
